var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('template-administrator',[_c('div',{attrs:{"slot":"container"},slot:"container"},[_c('create-ticket'),_c('br'),_c('table-ticket')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }